import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_SIZE } from '@/components/BaseTable/BaseTable';
import { LayoutDefault } from '@/components/LayoutDefault';
import { LayoutHeader } from '@/components/LayoutHeader';
import { LayoutHeaderTitle } from '@/components/LayoutHeaderTitle';
import { OrgDocsTable } from '@/components/OrgDocsTable/OrgDocsTable';
import { searchParam } from '@/utils/router';

const orgDocsSortingSchema = z.array(
  z.object({
    id: z.string(),
    desc: z.boolean(),
  })
);
const DEFAULT_ORG_DOCS_SORTING = [{ id: 'updated_at', desc: true }];

export const orgDocsSearchSchema = z.object({
  pageSize: z.number().default(DEFAULT_PAGE_SIZE).catch(DEFAULT_PAGE_SIZE),
  pageIndex: z.number().default(0).catch(0),
  search: searchParam().optional(),
  tag_ids: z.array(z.string()).catch([]).optional(),
  sorting: orgDocsSortingSchema.default(DEFAULT_ORG_DOCS_SORTING).catch(DEFAULT_ORG_DOCS_SORTING),
});

export type OrgDocsSearch = z.infer<typeof orgDocsSearchSchema>;

// The doc page carries the list's search so its back link can restore it. Zod 4
// applies `.default()` even under `.partial()`, which would stamp pageIndex,
// pageSize and sorting onto every back link, so this variant leaves a missing
// key absent and only substitutes the default for an invalid value.
export const orgDocsBackSearchSchema = z.object({
  pageSize: z.number().optional().catch(DEFAULT_PAGE_SIZE),
  pageIndex: z.number().optional().catch(0),
  search: searchParam().optional(),
  tag_ids: z.array(z.string()).catch([]).optional(),
  sorting: orgDocsSortingSchema.optional().catch(DEFAULT_ORG_DOCS_SORTING),
});

export const Route = createFileRoute('/$organizationName/org-docs/')({
  component: OrgDocsPage,
  validateSearch: orgDocsSearchSchema,
});

function OrgDocsPage() {
  return (
    <LayoutDefault
      navbarTitle="Org Docs"
      header={
        <LayoutHeader>
          <LayoutHeaderTitle title="Org Docs" />
        </LayoutHeader>
      }
    >
      <OrgDocsTable />
    </LayoutDefault>
  );
}
